export default __webpack_public_path__ + "static/media/Gida of the First Circle.0b200282.jpg";